import * as React from 'react'
import {observer} from 'mobx-react'
import {useStores} from '../../../lib/MobXProvider'
import {WidgetApi} from '../../../lib/WidgetApi'
import {WidgetFlag} from '../../../lib/WidgetFlag'
import {
  OverlayBlockWrapper,
  OverlayBlockWrapperProps,
} from '../../../lib/OverlayBlockWrapper'

///////////////////////////////////////////////////////////////////////////////

export const OverlayDataProtectionPolicyBlock = observer(() => {
  const {api} = useStores<{api: WidgetApi}>()
  const textHTML = api.trans('blocks.overlay_data_protection_policy.text_html')
  const closeOverlay = () =>
    api.flags.remove(WidgetFlag.SHOW_OVERLAY_DATA_PROTECTION_POLICY)
  const overlayProps: OverlayBlockWrapperProps = {
    showHeader: true,
    showClose: true,
    title: api.trans('blocks.overlay_data_protection_policy.title'),
    closeLabel: api.trans('blocks.overlay_data_protection_policy.close_label'),
    onClose: closeOverlay,
    closeOnClickOutside: true,
    closeOnEsc: true,
    className: 'overlay-data-protection-policy-block',
  }

  return (
    <OverlayBlockWrapper {...overlayProps}>
      <div
        className="overlay-data-protection-policy"
        dangerouslySetInnerHTML={{__html: textHTML}}
      />
    </OverlayBlockWrapper>
  )
})
